import React from 'react';
import classes from './ServiceItem.module.css';
import Button from '../../UI/Button';
import clsx from 'clsx';
const ServiceItem = ({ label, className }) => {
  return (
    <span className={clsx(classes.button, className)} variants="accent">
      {label}
    </span>
  );
};

export default ServiceItem;
